(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shower-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-shw-reviews]').forEach((section) => {
  const track = section.querySelector('[data-reviews-track]');
  const previous = section.querySelector('[data-reviews-prev]');
  const next = section.querySelector('[data-reviews-next]');
  const progress = section.querySelector('[data-reviews-progress]');
  if (!track) return;
  const move = (direction) => {
    const card = track.querySelector('.shw-reviews__card');
    if (!card) return;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 18), behavior: 'smooth' });
  };
  previous?.addEventListener('click', () => move(-1));
  next?.addEventListener('click', () => move(1));
  const update = () => {
    if (!progress) return;
    const maximum = track.scrollWidth - track.clientWidth;
    const ratio = maximum > 0 ? track.scrollLeft / maximum : 0;
    progress.style.transform = `scaleX(${Math.max(.2, ratio)})`;
  };
  track.addEventListener('scroll', update, { passive: true });
  update();
});
document.addEventListener('shopify:block:select', (event) => {
  const section = event.target.closest('[data-shw-reviews]');
  if (!section) return;
  const header = section.querySelector('.shw-reviews__head');
  window.setTimeout(() => header?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 260);
});

  } catch(e) { console.error(e); }
})();
})();
